/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { PayloadAction } from "@reduxjs/toolkit";
import { ITaskFilterState } from "../types";

export const setRegionFilterIdsAction = (state: ITaskFilterState, action: PayloadAction<string[]>) => {
  state.regionFilterIds = action.payload;
};

export const setSelectedTaskTypeAction = (state: ITaskFilterState, action: PayloadAction<string>) => {
  state.selectedTaskType = action.payload;
};

export const setSelectedTaskStatusAction = (state: ITaskFilterState, action: PayloadAction<string>) => {
  state.selectedTaskStatus = action.payload;
};

export const resetTaskFiltersAction = (state: ITaskFilterState) => {
  state.regionFilterIds = [];
  state.selectedTaskType = "";
  state.selectedTaskStatus = "";
};
